<script lang="ts">
  import { _ } from 'svelte-i18n'
  import { fly } from 'svelte/transition'
  import AtomButton from '../atoms/AtomButton.svelte'
  import AtomIcon from '../atoms/AtomIcon.svelte'
  import Refresh from '$lib/icons/fontawesome/refresh.svelte'
  import { newVersionAvailable } from '$lib/utils/version-check'

  const reloadWithoutCache = () => {
    const url = new URL(window.location.href)
    url.searchParams.set('_reload', Date.now().toString())
    window.location.href = url.toString()
  }
</script>

{#if $newVersionAvailable}
  <div
    class="absolute top-0 left-0 right-0 z-[100] flex justify-center"
    transition:fly|global={{ y: -20, opacity: 100 }}
  >
    <div class="px-4 py-2 flex gap-3 items-center rounded-b-md bg-blue-500 text-xs text-white fill-white">
      <span>{$_('d.frontendVersionUpdate.available')}</span>
      <AtomButton
        variant="secondary"
        size="small"
        onClick={reloadWithoutCache}
        class="!bg-white !text-blue-500 hover:!bg-blue-50"
      >
        <AtomIcon slot="icon" size={3}>
          <Refresh />
        </AtomIcon>
        {$_('d.frontendVersionUpdate.reload')}
      </AtomButton>
    </div>
  </div>
{/if}
